import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { getRebuildAPI } from "@rebuild/shared/api";
import type { CreateLineItemFeedbackBody } from "@rebuild/shared/generated/models/createLineItemFeedbackBody";

const { feedbackControllerCreateLineItemFeedback } = getRebuildAPI();

export function useSubmitLineItemFeedbackMutation() {
  return useMutation({
    mutationFn: (params: CreateLineItemFeedbackBody) => {
      return feedbackControllerCreateLineItemFeedback(params);
    },
    onSuccess: () => {
      toast.success("Thanks for your feedback — we'll take a look!");
    },
    onError: () => {
      toast.error("Failed to submit feedback. Please try again.");
    },
  });
}
